import commonActionTypes from './action-types';

export const setContext = payload => ({
  type: commonActionTypes.SET_CONTEXT,
  payload,
});

export const fetchAllLabs = payload => ({
  type: commonActionTypes.FETCH_ALL_LABS,
  payload,
});

export const fetchAllLabsSuccess = payload => ({
  type: commonActionTypes.FETCH_ALL_LABS_SUCCESS,
  payload,
});

export const fetchAllLabsFail = payload => ({
  type: commonActionTypes.FETCH_ALL_LABS_FAIL,
  payload,
});

export const fetchAllChemists = payload => ({
  type: commonActionTypes.FETCH_ALL_CHEMISTS,
  payload,
});

export const fetchAllChemistsSuccess = payload => ({
  type: commonActionTypes.FETCH_ALL_CHEMISTS_SUCCESS,
  payload,
});

export const fetchAllChemistsFail = payload => ({
  type: commonActionTypes.FETCH_ALL_CHEMISTS_FAIL,
  payload,
});

export const fetchAllUsers = payload => ({
  type: commonActionTypes.FETCH_ALL_USERS,
  payload,
});

export const fetchAllUsersSuccess = payload => ({
  type: commonActionTypes.FETCH_ALL_USERS_SUCCESS,
  payload,
});

export const fetchAllUsersFail = payload => ({
  type: commonActionTypes.FETCH_ALL_USERS_FAIL,
  payload,
});

export const fetchUploadContentSubmission = payload => ({
  type: commonActionTypes.FETCH_UPLOAD_CONTENT_SUBMISSION,
  payload,
});

export const fetchUploadContentSubmissionSuccess = () => ({
  type: commonActionTypes.FETCH_UPLOAD_CONTENT_SUBMISSION_SUCCESS,
});

export const fetchUploadContentSubmissionFail = () => ({
  type: commonActionTypes.FETCH_UPLOAD_CONTENT_SUBMISSION_FAIL,
});
